import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkComparePeriodFieldsFragment = { __typename?: 'GrowerBenchmarkPeriod', periodId: string, label: string, kind: Types.GrowerBenchmarkPeriodKind, cadence: Types.GrowerBenchmarkReportingCadence, approvedAt?: Types.TDateISO | null, comparisonPeriodId?: string | null };

export type GrowerBenchmarkCompareCohortFacetValueFieldsFragment = { __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string };

export type GrowerBenchmarkCompareCohortFieldsFragment = { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, label: string, firmCount: number, isBelowFloor: boolean, floorFirmCount: number, reportedFirmCount: number, totalFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> };

export type GrowerBenchmarkCompareMetricBandFieldsFragment = { __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null };

export type GrowerBenchmarkCompareMetricDefinitionFieldsFragment = { __typename?: 'GrowerBenchmarkMetricDefinition', metricKey: string, label: string, formula: string, inputs: Array<string>, unit: Types.GrowerBenchmarkMetricUnit, decimals: number, direction: Types.GrowerBenchmarkMetricDirection, target?: number | null, groupKey: string, sortOrder: number, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> };

export type GrowerBenchmarkCompareFirmMetricPointFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null };

export type GrowerBenchmarkCompareFirmMetricSeriesFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricSeries', metricKey: string, points: Array<{ __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null }> };

export type GrowerBenchmarkCompareFacetOptionFieldsFragment = { __typename?: 'GrowerBenchmarkCohortFacetOption', value: string, label: string, firmCount: number, isBelowFloor: boolean };

export type GrowerBenchmarkCompareFacetFieldsFragment = { __typename?: 'GrowerBenchmarkCohortFacet', facetKey: string, label: string, options: Array<{ __typename?: 'GrowerBenchmarkCohortFacetOption', value: string, label: string, firmCount: number, isBelowFloor: boolean }> };

export type GrowerBenchmarkCompareMetricStatisticsFieldsFragment = { __typename?: 'GrowerBenchmarkCohortMetricStatistics', metricKey: string, cohortKey: string, periodId: string, firmCount: number, reportedCount: number, isBelowFloor: boolean, floorFirmCount: number, median?: number | null, topQuartile?: number | null, lowerQuartile?: number | null, minimum?: number | null, maximum?: number | null, priorPeriodMedian?: number | null };

export type GrowerBenchmarkCompareComparisonPointFieldsFragment = { __typename?: 'GrowerBenchmarkComparisonPoint', periodId: string, label: string, value: number };

export type GrowerBenchmarkCompareFirmMetricValueFieldsFragment = { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, value?: number | null, threeYearAverage?: number | null, rank?: number | null, rankOf?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', periodId: string, label: string, value: number }> };

export type GrowerBenchmarkComparePeerRowFieldsFragment = { __typename?: 'GrowerBenchmarkPeerRow', firmLabel: string, isSelf: boolean, value?: number | null, priorPeriodValue?: number | null, threeYearAverage?: number | null };

export type GrowerBenchmarkCompareMetricFieldsFragment = { __typename?: 'GrowerBenchmarkCompareMetric', definition: { __typename?: 'GrowerBenchmarkMetricDefinition', metricKey: string, label: string, formula: string, inputs: Array<string>, unit: Types.GrowerBenchmarkMetricUnit, decimals: number, direction: Types.GrowerBenchmarkMetricDirection, target?: number | null, groupKey: string, sortOrder: number, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', metricKey: string, cohortKey: string, periodId: string, firmCount: number, reportedCount: number, isBelowFloor: boolean, floorFirmCount: number, median?: number | null, topQuartile?: number | null, lowerQuartile?: number | null, minimum?: number | null, maximum?: number | null, priorPeriodMedian?: number | null }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, value?: number | null, threeYearAverage?: number | null, rank?: number | null, rankOf?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', periodId: string, label: string, value: number }> } | null, rows: Array<{ __typename?: 'GrowerBenchmarkPeerRow', firmLabel: string, isSelf: boolean, value?: number | null, priorPeriodValue?: number | null, threeYearAverage?: number | null }> };

export type GrowerBenchmarkComparePageQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GrowerBenchmarkComparePageQuery = { __typename?: 'Query', growerBenchmarkFirmHome?: { __typename?: 'GrowerBenchmarkFirmHome', firmId: string, selfFirmLabel: string, communityId: string, segment: Types.GrowerBenchmarkCommunitySegment, period: { __typename?: 'GrowerBenchmarkPeriod', periodId: string, label: string, kind: Types.GrowerBenchmarkPeriodKind, cadence: Types.GrowerBenchmarkReportingCadence, approvedAt?: Types.TDateISO | null, comparisonPeriodId?: string | null }, comparisonPeriod?: { __typename?: 'GrowerBenchmarkPeriod', periodId: string, label: string, kind: Types.GrowerBenchmarkPeriodKind, cadence: Types.GrowerBenchmarkReportingCadence, approvedAt?: Types.TDateISO | null, comparisonPeriodId?: string | null } | null, cohort: { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, label: string, firmCount: number, isBelowFloor: boolean, floorFirmCount: number, reportedFirmCount: number, totalFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> }, series: Array<{ __typename?: 'GrowerBenchmarkFirmMetricSeries', metricKey: string, points: Array<{ __typename?: 'GrowerBenchmarkFirmMetricPoint', periodId: string, value?: number | null }> }> } | null, growerBenchmarkMetricDefinitions: Array<{ __typename?: 'GrowerBenchmarkMetricDefinition', metricKey: string, label: string, formula: string, inputs: Array<string>, unit: Types.GrowerBenchmarkMetricUnit, decimals: number, direction: Types.GrowerBenchmarkMetricDirection, target?: number | null, groupKey: string, sortOrder: number, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }>, growerBenchmarkPeriods: Array<{ __typename?: 'GrowerBenchmarkPeriod', periodId: string, label: string, kind: Types.GrowerBenchmarkPeriodKind, cadence: Types.GrowerBenchmarkReportingCadence, approvedAt?: Types.TDateISO | null, comparisonPeriodId?: string | null }> };

export type GrowerBenchmarkCompareFacetsQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  periodId: Types.Scalars['String']['input'];
}>;


export type GrowerBenchmarkCompareFacetsQuery = { __typename?: 'Query', growerBenchmarkCohortFacets: Array<{ __typename?: 'GrowerBenchmarkCohortFacet', facetKey: string, label: string, options: Array<{ __typename?: 'GrowerBenchmarkCohortFacetOption', value: string, label: string, firmCount: number, isBelowFloor: boolean }> }> };

export type GrowerBenchmarkCompareCohortQueryVariables = Types.Exact<{
  selection: Types.GrowerBenchmarkCohortSelectionInput;
}>;


export type GrowerBenchmarkCompareCohortQuery = { __typename?: 'Query', growerBenchmarkCohort: { __typename?: 'GrowerBenchmarkCohort', cohortKey: string, label: string, firmCount: number, isBelowFloor: boolean, floorFirmCount: number, reportedFirmCount: number, totalFirmCount: number, statisticsUpdatedAt?: Types.TDateISO | null, facets: Array<{ __typename?: 'GrowerBenchmarkCohortFacetValue', facetKey: string, label: string, value: string, valueLabel: string }> } };

export type GrowerBenchmarkCompareMetricsQueryVariables = Types.Exact<{
  selection: Types.GrowerBenchmarkCohortSelectionInput;
  metricKeys?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type GrowerBenchmarkCompareMetricsQuery = { __typename?: 'Query', growerBenchmarkCompare: Array<{ __typename?: 'GrowerBenchmarkCompareMetric', definition: { __typename?: 'GrowerBenchmarkMetricDefinition', metricKey: string, label: string, formula: string, inputs: Array<string>, unit: Types.GrowerBenchmarkMetricUnit, decimals: number, direction: Types.GrowerBenchmarkMetricDirection, target?: number | null, groupKey: string, sortOrder: number, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> }, statistics: { __typename?: 'GrowerBenchmarkCohortMetricStatistics', metricKey: string, cohortKey: string, periodId: string, firmCount: number, reportedCount: number, isBelowFloor: boolean, floorFirmCount: number, median?: number | null, topQuartile?: number | null, lowerQuartile?: number | null, minimum?: number | null, maximum?: number | null, priorPeriodMedian?: number | null }, self?: { __typename?: 'GrowerBenchmarkFirmMetricValue', metricKey: string, periodId: string, value?: number | null, threeYearAverage?: number | null, rank?: number | null, rankOf?: number | null, priorPeriods: Array<{ __typename?: 'GrowerBenchmarkComparisonPoint', periodId: string, label: string, value: number }> } | null, rows: Array<{ __typename?: 'GrowerBenchmarkPeerRow', firmLabel: string, isSelf: boolean, value?: number | null, priorPeriodValue?: number | null, threeYearAverage?: number | null }> }> };

export const GrowerBenchmarkComparePeriodFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkComparePeriodFields on GrowerBenchmarkPeriod {
  periodId
  label
  kind
  cadence
  approvedAt
  comparisonPeriodId
}
    `, {"fragmentName":"GrowerBenchmarkComparePeriodFields"});
export const GrowerBenchmarkCompareCohortFacetValueFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
    `, {"fragmentName":"GrowerBenchmarkCompareCohortFacetValueFields"});
export const GrowerBenchmarkCompareCohortFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareCohortFields on GrowerBenchmarkCohort {
  cohortKey
  label
  facets {
    ...GrowerBenchmarkCompareCohortFacetValueFields
  }
  firmCount
  isBelowFloor
  floorFirmCount
  reportedFirmCount
  totalFirmCount
  statisticsUpdatedAt
}
    fragment GrowerBenchmarkCompareCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}`, {"fragmentName":"GrowerBenchmarkCompareCohortFields"});
export const GrowerBenchmarkCompareFirmMetricPointFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareFirmMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}
    `, {"fragmentName":"GrowerBenchmarkCompareFirmMetricPointFields"});
export const GrowerBenchmarkCompareFirmMetricSeriesFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareFirmMetricSeriesFields on GrowerBenchmarkFirmMetricSeries {
  metricKey
  points {
    ...GrowerBenchmarkCompareFirmMetricPointFields
  }
}
    fragment GrowerBenchmarkCompareFirmMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}`, {"fragmentName":"GrowerBenchmarkCompareFirmMetricSeriesFields"});
export const GrowerBenchmarkCompareFacetOptionFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareFacetOptionFields on GrowerBenchmarkCohortFacetOption {
  value
  label
  firmCount
  isBelowFloor
}
    `, {"fragmentName":"GrowerBenchmarkCompareFacetOptionFields"});
export const GrowerBenchmarkCompareFacetFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareFacetFields on GrowerBenchmarkCohortFacet {
  facetKey
  label
  options {
    ...GrowerBenchmarkCompareFacetOptionFields
  }
}
    fragment GrowerBenchmarkCompareFacetOptionFields on GrowerBenchmarkCohortFacetOption {
  value
  label
  firmCount
  isBelowFloor
}`, {"fragmentName":"GrowerBenchmarkCompareFacetFields"});
export const GrowerBenchmarkCompareMetricBandFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
    `, {"fragmentName":"GrowerBenchmarkCompareMetricBandFields"});
export const GrowerBenchmarkCompareMetricDefinitionFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  metricKey
  label
  formula
  inputs
  unit
  decimals
  direction
  bands {
    ...GrowerBenchmarkCompareMetricBandFields
  }
  target
  groupKey
  sortOrder
}
    fragment GrowerBenchmarkCompareMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}`, {"fragmentName":"GrowerBenchmarkCompareMetricDefinitionFields"});
export const GrowerBenchmarkCompareMetricStatisticsFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareMetricStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  metricKey
  cohortKey
  periodId
  firmCount
  reportedCount
  isBelowFloor
  floorFirmCount
  median
  topQuartile
  lowerQuartile
  minimum
  maximum
  priorPeriodMedian
}
    `, {"fragmentName":"GrowerBenchmarkCompareMetricStatisticsFields"});
export const GrowerBenchmarkCompareComparisonPointFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareComparisonPointFields on GrowerBenchmarkComparisonPoint {
  periodId
  label
  value
}
    `, {"fragmentName":"GrowerBenchmarkCompareComparisonPointFields"});
export const GrowerBenchmarkCompareFirmMetricValueFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareFirmMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  value
  priorPeriods {
    ...GrowerBenchmarkCompareComparisonPointFields
  }
  threeYearAverage
  rank
  rankOf
}
    fragment GrowerBenchmarkCompareComparisonPointFields on GrowerBenchmarkComparisonPoint {
  periodId
  label
  value
}`, {"fragmentName":"GrowerBenchmarkCompareFirmMetricValueFields"});
export const GrowerBenchmarkComparePeerRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkComparePeerRowFields on GrowerBenchmarkPeerRow {
  firmLabel
  isSelf
  value
  priorPeriodValue
  threeYearAverage
}
    `, {"fragmentName":"GrowerBenchmarkComparePeerRowFields"});
export const GrowerBenchmarkCompareMetricFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkCompareMetricFields on GrowerBenchmarkCompareMetric {
  definition {
    ...GrowerBenchmarkCompareMetricDefinitionFields
  }
  statistics {
    ...GrowerBenchmarkCompareMetricStatisticsFields
  }
  self {
    ...GrowerBenchmarkCompareFirmMetricValueFields
  }
  rows {
    ...GrowerBenchmarkComparePeerRowFields
  }
}
    fragment GrowerBenchmarkCompareMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkCompareMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  metricKey
  label
  formula
  inputs
  unit
  decimals
  direction
  bands {
    ...GrowerBenchmarkCompareMetricBandFields
  }
  target
  groupKey
  sortOrder
}
fragment GrowerBenchmarkCompareMetricStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  metricKey
  cohortKey
  periodId
  firmCount
  reportedCount
  isBelowFloor
  floorFirmCount
  median
  topQuartile
  lowerQuartile
  minimum
  maximum
  priorPeriodMedian
}
fragment GrowerBenchmarkCompareComparisonPointFields on GrowerBenchmarkComparisonPoint {
  periodId
  label
  value
}
fragment GrowerBenchmarkCompareFirmMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  value
  priorPeriods {
    ...GrowerBenchmarkCompareComparisonPointFields
  }
  threeYearAverage
  rank
  rankOf
}
fragment GrowerBenchmarkComparePeerRowFields on GrowerBenchmarkPeerRow {
  firmLabel
  isSelf
  value
  priorPeriodValue
  threeYearAverage
}`, {"fragmentName":"GrowerBenchmarkCompareMetricFields"});
export const GrowerBenchmarkComparePageDocument = new TypedDocumentString(`
    query GrowerBenchmarkComparePage($communityId: String!, $periodId: String) {
  growerBenchmarkFirmHome(communityId: $communityId, periodId: $periodId) {
    firmId
    selfFirmLabel
    communityId
    segment
    period {
      ...GrowerBenchmarkComparePeriodFields
    }
    comparisonPeriod {
      ...GrowerBenchmarkComparePeriodFields
    }
    cohort {
      ...GrowerBenchmarkCompareCohortFields
    }
    series {
      ...GrowerBenchmarkCompareFirmMetricSeriesFields
    }
  }
  growerBenchmarkMetricDefinitions(communityId: $communityId) {
    ...GrowerBenchmarkCompareMetricDefinitionFields
  }
  growerBenchmarkPeriods(communityId: $communityId) {
    ...GrowerBenchmarkComparePeriodFields
  }
}
    fragment GrowerBenchmarkComparePeriodFields on GrowerBenchmarkPeriod {
  periodId
  label
  kind
  cadence
  approvedAt
  comparisonPeriodId
}
fragment GrowerBenchmarkCompareCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
fragment GrowerBenchmarkCompareCohortFields on GrowerBenchmarkCohort {
  cohortKey
  label
  facets {
    ...GrowerBenchmarkCompareCohortFacetValueFields
  }
  firmCount
  isBelowFloor
  floorFirmCount
  reportedFirmCount
  totalFirmCount
  statisticsUpdatedAt
}
fragment GrowerBenchmarkCompareMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkCompareMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  metricKey
  label
  formula
  inputs
  unit
  decimals
  direction
  bands {
    ...GrowerBenchmarkCompareMetricBandFields
  }
  target
  groupKey
  sortOrder
}
fragment GrowerBenchmarkCompareFirmMetricPointFields on GrowerBenchmarkFirmMetricPoint {
  periodId
  value
}
fragment GrowerBenchmarkCompareFirmMetricSeriesFields on GrowerBenchmarkFirmMetricSeries {
  metricKey
  points {
    ...GrowerBenchmarkCompareFirmMetricPointFields
  }
}`);
export const GrowerBenchmarkCompareFacetsDocument = new TypedDocumentString(`
    query GrowerBenchmarkCompareFacets($communityId: String!, $periodId: String!) {
  growerBenchmarkCohortFacets(communityId: $communityId, periodId: $periodId) {
    ...GrowerBenchmarkCompareFacetFields
  }
}
    fragment GrowerBenchmarkCompareFacetOptionFields on GrowerBenchmarkCohortFacetOption {
  value
  label
  firmCount
  isBelowFloor
}
fragment GrowerBenchmarkCompareFacetFields on GrowerBenchmarkCohortFacet {
  facetKey
  label
  options {
    ...GrowerBenchmarkCompareFacetOptionFields
  }
}`);
export const GrowerBenchmarkCompareCohortDocument = new TypedDocumentString(`
    query GrowerBenchmarkCompareCohort($selection: GrowerBenchmarkCohortSelectionInput!) {
  growerBenchmarkCohort(selection: $selection) {
    ...GrowerBenchmarkCompareCohortFields
  }
}
    fragment GrowerBenchmarkCompareCohortFacetValueFields on GrowerBenchmarkCohortFacetValue {
  facetKey
  label
  value
  valueLabel
}
fragment GrowerBenchmarkCompareCohortFields on GrowerBenchmarkCohort {
  cohortKey
  label
  facets {
    ...GrowerBenchmarkCompareCohortFacetValueFields
  }
  firmCount
  isBelowFloor
  floorFirmCount
  reportedFirmCount
  totalFirmCount
  statisticsUpdatedAt
}`);
export const GrowerBenchmarkCompareMetricsDocument = new TypedDocumentString(`
    query GrowerBenchmarkCompareMetrics($selection: GrowerBenchmarkCohortSelectionInput!, $metricKeys: [String!]) {
  growerBenchmarkCompare(selection: $selection, metricKeys: $metricKeys) {
    ...GrowerBenchmarkCompareMetricFields
  }
}
    fragment GrowerBenchmarkCompareMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}
fragment GrowerBenchmarkCompareMetricDefinitionFields on GrowerBenchmarkMetricDefinition {
  metricKey
  label
  formula
  inputs
  unit
  decimals
  direction
  bands {
    ...GrowerBenchmarkCompareMetricBandFields
  }
  target
  groupKey
  sortOrder
}
fragment GrowerBenchmarkCompareMetricStatisticsFields on GrowerBenchmarkCohortMetricStatistics {
  metricKey
  cohortKey
  periodId
  firmCount
  reportedCount
  isBelowFloor
  floorFirmCount
  median
  topQuartile
  lowerQuartile
  minimum
  maximum
  priorPeriodMedian
}
fragment GrowerBenchmarkCompareComparisonPointFields on GrowerBenchmarkComparisonPoint {
  periodId
  label
  value
}
fragment GrowerBenchmarkCompareFirmMetricValueFields on GrowerBenchmarkFirmMetricValue {
  metricKey
  periodId
  value
  priorPeriods {
    ...GrowerBenchmarkCompareComparisonPointFields
  }
  threeYearAverage
  rank
  rankOf
}
fragment GrowerBenchmarkComparePeerRowFields on GrowerBenchmarkPeerRow {
  firmLabel
  isSelf
  value
  priorPeriodValue
  threeYearAverage
}
fragment GrowerBenchmarkCompareMetricFields on GrowerBenchmarkCompareMetric {
  definition {
    ...GrowerBenchmarkCompareMetricDefinitionFields
  }
  statistics {
    ...GrowerBenchmarkCompareMetricStatisticsFields
  }
  self {
    ...GrowerBenchmarkCompareFirmMetricValueFields
  }
  rows {
    ...GrowerBenchmarkComparePeerRowFields
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GrowerBenchmarkComparePage: build.query<GrowerBenchmarkComparePageQuery, GrowerBenchmarkComparePageQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkComparePageDocument, variables })
    }),
    GrowerBenchmarkCompareFacets: build.query<GrowerBenchmarkCompareFacetsQuery, GrowerBenchmarkCompareFacetsQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkCompareFacetsDocument, variables })
    }),
    GrowerBenchmarkCompareCohort: build.query<GrowerBenchmarkCompareCohortQuery, GrowerBenchmarkCompareCohortQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkCompareCohortDocument, variables })
    }),
    GrowerBenchmarkCompareMetrics: build.query<GrowerBenchmarkCompareMetricsQuery, GrowerBenchmarkCompareMetricsQueryVariables>({
      query: (variables) => ({ document: GrowerBenchmarkCompareMetricsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGrowerBenchmarkComparePageQuery, useLazyGrowerBenchmarkComparePageQuery, useGrowerBenchmarkCompareFacetsQuery, useLazyGrowerBenchmarkCompareFacetsQuery, useGrowerBenchmarkCompareCohortQuery, useLazyGrowerBenchmarkCompareCohortQuery, useGrowerBenchmarkCompareMetricsQuery, useLazyGrowerBenchmarkCompareMetricsQuery } = injectedRtkApi;
